/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  eqeqeq,
  react/jsx-no-target-blank
*/
import React, { Component } from 'react';
import Button from 'common/components/button';
import './index.scss';

const dateFilter = (input) => input
  .replace('/', '-')
  .replace(/[^\d-]/g, '');

const validDate = /\d{4}-\d{2}-\d{2}/;


export default class AdvancedForm extends Component {
    state = this.getEmptyState();


    getEmptyState() {
      return {
        filter: 'all',
        signer: '',
        sender: '',
        createdFrom: '',
        createdTo: '',
        contains: '',
        owner: '',
        testMode: false,
      };
    }

    handleClear = () => this.setState(this.getEmptyState());

    handleFilter = (event) => this.setState({ filter: event.target.value });

    handleSigner = (event) => this.setState({ signer: event.target.value });

    handleSender = (event) => this.setState({ sender: event.target.value });

    handleContains = (event) => this.setState({ contains: event.target.value });

    handleOwner = (event) => this.setState({ owner: event.target.value });

    handleTestMode = (event) => this.setState({ testMode: event.target.checked });

    handleCreatedFrom = (event) => this.setState({
      createdFrom: dateFilter(event.target.value),
    });

    handleCreatedTo = (event) => this.setState({
      createdTo: dateFilter(event.target.value),
    });

    handleSearch = () => {
      const data = {
        // Don't send "all" as it's not a valid filter
        filter: (this.state.filter !== 'all' ? this.state.filter : null),
        signer: this.state.signer,
        sender: this.state.sender,

        ...(this.validDates() ? {
          created: `[${this.state.createdFrom} TO ${this.state.createdTo}]`,
        } : {}),

        contains: this.state.contains,
        owner: this.state.owner,
        testMode: this.state.testMode,
      };


      this.props.onSearch(data);
    };

    onSubmit = (event) => {
      event.preventDefault();
      this.handleSearch();
    };

    validDates() {
      if (this.state.createdFrom != '' || this.state.createdTo != '') {
        return validDate.test(this.state.createdFrom) && validDate.test(this.state.createdTo);
      }
    }

    renderFilters() {
      if (this.props.siteCode === 'F') {
        return (
          <React.Fragment>
            <option value="all">All</option>
            {(this.props.includeAllTeam === true
              ? <option value="all_team">All Team documents</option>
              : null)}
            <option value="sent">Sent</option>
            <option value="received">Received</option>
            <option value="draft">Drafts</option>
          </React.Fragment>
        );
      }

      return (
        <React.Fragment>
          <option value="all">All</option>
          <optgroup label="Status">
            {(this.props.includeAllTeam === true
              ? <option value="all_team">All Team documents</option>
              : null)}
            <option value="completed">Completed</option>
            <option value="declined">Declined</option>
            <option value="awaiting_my_signature">Awaiting my signature</option>
            <option value="out_for_signature">Out for signature</option>
            <option value="draft">Draft</option>
          </optgroup>
          <optgroup label="Type">
            <option value="template">Template</option>
            <option value="template_link">Template link</option>
          </optgroup>
        </React.Fragment>
      );
    }

    render() {

      let submitDisabled = false;
      if (this.state.createdFrom != '' || this.state.createdTo != '') {
        submitDisabled = !this.validDates();
      }

      return <div className="advanced-search__popover">
        <form onSubmit={this.onSubmit}>
          <table className="advanced-search__inputs">
            <tbody>
              <tr>
                <td>
                  <label htmlFor="advanced-search__type-status">Type/Status</label>
                </td>
                <td>
                  <select id="advanced-search__type-status" value={this.state.filter} onChange={this.handleFilter}>
                    {this.renderFilters()}
                  </select>
                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="advanced-search__signer">To</label>
                </td>
                <td>
                  <input
                    type="text"
                    onChange={this.handleSigner}
                    value={this.state.signer}
                    id="advanced-search__signer" />
                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="advanced-search__sender">From</label>
                </td>
                <td>
                  <input
                    type="text"
                    onChange={this.handleSender}
                    value={this.state.sender}
                    id="advanced-search__signer" />
                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="advanced-search__date-from">
                                Creation date
                  </label>
                </td>
                <td>
                  <input
                    type="text"
                    className="advanced-search__date"
                    placeholder="2012-01-31"
                    onChange={this.handleCreatedFrom}
                    value={this.state.createdFrom}
                    maxLength={10}
                    id="advanced-search__date-from" />
                  {' to '}
                  <input
                    type="text"
                    className="advanced-search__date"
                    placeholder="2018-01-15"
                    onChange={this.handleCreatedTo}
                    value={this.state.createdTo}
                    maxLength={10} />
                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="advanced-search__contains">Contains</label>
                </td>
                <td>
                  <input
                    type="text"
                    onChange={this.handleContains}
                    value={this.state.contains}
                    id="advanced-search__contains" />
                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="advanced-search__template-owner">Template owner</label>
                </td>
                <td>
                  <input
                    type="text"
                    onChange={this.handleOwner}
                    value={this.state.owner}
                    id="advanced-search__template-owner" />
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <label htmlFor="advanced-search__test-mode" className="advanced-search__test-mode-label">
                    <input type="checkbox" onChange={this.handleTestMode} checked={this.state.testMode} id="advanced-search__test-mode" />
                                Test mode (API)
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="advanced-search__buttons">
            <div className="advanced-search__button-group advanced-search__button-group--left">
              <a href="https://faq.hellosign.com/hc/en-us/articles/115014893868" target="_blank">Learn more</a>
            </div>
            <div className="advanced-search__button-group advanced-search__button-group--right">
              <a onClick={this.handleClear}>Clear</a>
              <Button
                className="advanced-search__button-group__button"
                onClick={this.handleSearch}
                type="submit"
                buttonColor="cerulean"
                disabled={submitDisabled}
                buttonText="Search" />
            </div>
          </div>
        </form>
      </div>;
    }

}
